import apiClient from "./apiClient";

class FeedbackService {
  static async submitFeedback(feedbackData) {
    try {
      const response = await apiClient.post("/feedback/submit", feedbackData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getFeedbackByMessageId(messageId) {
    try {
      const response = await apiClient.post("/feedback/get", {
        message_id: messageId,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default FeedbackService;

